module.exports = __webpack_public_path__ + "catalog/items/firesafety/Lift-Symbol/Lift-Symbol.svg";